import { render, staticRenderFns } from "./MultigameRedirectEffect.vue?vue&type=template&id=1cb8aed4&"
import script from "./MultigameRedirectEffect.vue?vue&type=script&lang=ts&"
export * from "./MultigameRedirectEffect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports